import { render, staticRenderFns } from "./FavSysRemindList.vue?vue&type=template&id=afde8a02"
import script from "./FavSysRemindList.vue?vue&type=script&lang=ts"
export * from "./FavSysRemindList.vue?vue&type=script&lang=ts"
import style0 from "./FavSysRemindList.vue?vue&type=style&index=0&id=afde8a02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports